export default __webpack_public_path__ + "static/media/iread1.f7a0df0a.jpeg";